import { Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';
import { CaseService } from 'src/app/shared/services/case.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-external-actions',
  templateUrl: './external-actions.component.html',
  styleUrls: ['./external-actions.component.scss']
})
export class ExternalActionsComponent implements OnInit {
  public loadfromparent = new BehaviorSubject<any>('');
  public loadfromparent2 = new BehaviorSubject<any>('');
  public loadfromparent3 = new BehaviorSubject<any>('');
  @Input() eCaseId:any;
  closeResult: string;
  AttachShow: boolean = false;
  caseId:any;
  externalActionsArr:any=[];
  procedureArr:any=[];
  partyArr:any = [];
  procedureTypeId : any;
  partyId : any;
  other : any;
  dateOfAction:any;
  
  today = new Date();
  currentDate:NgbDateStruct;
  currentDateHijri:NgbDateStruct;
  comment : any;
  externalActionId:any;
  editedExternalAction:any;
  editedDate:any;
  caseDetails:any;
  addExternalActionShow:boolean=false;
  editExternalActionShow: boolean=false;
  constructor(private dateformat: DateFormatterService ,  private caseService: CaseService,public sharedService : SharedHttpService,private lookupService : LookupService) { }


  ngOnInit(): void {
    this.loadData();
    this.caseId = this.caseService.case.caseId;
    
    this.caseDetails=this.caseService.case;
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
    this.dateOfAction = this.dateformat.ToGregorian2(this.currentDate );
    this.currentDateHijri = this.dateformat.ToHijri(this.currentDate );
    this.partyArr =this.lookupService.getLockup('party');
    this.procedureArr =this.lookupService.getLockup('procedure');
  }
  loadData(){
    this.sharedService.get(`api/ExternalAction/GetExternalActions?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.externalActionsArr = res;
    })
  }
  openCreateModal(){
    this.externalActionId=undefined;
    this.procedureTypeId = undefined;
    this.partyId = undefined;
    this.other = undefined;
    this.dateOfAction = undefined;
    this.comment = undefined;
    this.AttachShow=false;
   this.addExternalActionShow=true;
  }
  AddExternalAction(){
    let obj=  {
      "externalActionId": this.externalActionId,
      "caseId": this.caseId,
      "procedureId": this.procedureTypeId,
      "partyId": this.partyId,
      "other": this.other,
      "dateOfAction": this.dateOfAction,
      "comment": this.comment,
    };
    if(this.externalActionId){
      this.sharedService.put(`api/ExternalAction/Update`, [obj]).subscribe(res => {
     
        this.loadData();
        this.sharedService.showSuccessKey("ExternalActionEditedSuccessfully");
      });

    }else{
      this.sharedService.post(`api/ExternalAction/Insert`,[obj]).subscribe(res=>{
       
        this.externalActionId=res[0].externalActionId;
        this.sharedService.showSuccessKey("ExternalActionAddedSuccessfully");
        this.loadData();
        this.AttachShow=true;
        this.loadfromparent.next({ "id": this.externalActionId, "IsReadOnly": false });

      });

    }
  }

  AddExternalActionAndClose(){
    let obj=  {
      "externalActionId": this.externalActionId,
      "caseId": this.caseId,
      "procedureId": this.procedureTypeId,
      "partyId": this.partyId,
      "other": this.other,
      "dateOfAction": this.dateOfAction,
      "comment": this.comment,
    };
 
      this.sharedService.post(`api/ExternalAction/Insert`,[obj]).subscribe(res=>{
       
        this.externalActionId=res[0].externalActionId;
        this.sharedService.showSuccessKey("ExternalActionAddedSuccessfully");
        this.loadData();
       this.addExternalActionShow=false;
      });
 
  }
  SelectedDateChange($event) {
    this.dateOfAction = this.dateformat.ToGregorian2($event);
  }
  SelectedDateChangeEdit($event) {
    this.editedExternalAction.dateOfAction = this.dateformat.ToGregorian2($event);
  }
  deleteExternalAction(externalActionId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.externalActionId = externalActionId;
  }
  externalActionAttachment(id, model) {
    this.sharedService.openLarge(model);
    this.loadfromparent3.next({ "id": id, "IsReadOnly": false });
  }

  onDeleteExternalAction(modal) {
    this.sharedService.delete(`api/ExternalAction/Delete`, [this.externalActionId]).subscribe((response) => {
      this.externalActionId=undefined
      this.loadData();
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("ExternalActionDeleteSuccessfully");
      },
     
    );
  }
  editExternalAction(externalAction){
    this.editedExternalAction=undefined;
    this.editedExternalAction= {...externalAction};
    this.loadfromparent2.next({ "id": externalAction.externalActionId, "IsReadOnly": false });
    this.editedDate = this.sharedService.convertDateToNgbDateStruct(externalAction.dateOfAction);
    this.editExternalActionShow=true;
  }
  onEditExternalAction() {
    let obj = {
      "externalActionId": this.editedExternalAction.externalActionId,
      "caseId": this.caseId,
      "procedureId": this.editedExternalAction.procedureId,
      "partyId": this.editedExternalAction.partyId,
      "other": this.editedExternalAction.other ,
      "dateOfAction": this.editedExternalAction.dateOfAction,
      "isDeleted": false,
      "comment": this.editedExternalAction.comment,
    };
    this.sharedService.put(`api/ExternalAction/Update`, [obj]).subscribe(res => {
      
      this.loadData();
      this.sharedService.showSuccessKey("ExternalActionEditedSuccessfully");
      this.editExternalActionShow=false;
      this.addExternalActionShow=false;
    });
  }
  externalActionPreview(externalAction,modal){
    this.editedExternalAction=undefined;
    this.editedExternalAction= {...externalAction};
    this.sharedService.openLarge(modal);
  }

}
